module.exports = __webpack_public_path__ + "static/bg-a8428eeae1eb0d27961238912481189c.jpg";